import { extendADNDDropTarget } from './ADNDDropTarget'

const PRIVATE = {
  fetchData(_state, event) {
    if (event && event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length) {
      const files = []
      for (let i = 0; i < event.dataTransfer.files.length; i++) {
        files.push(event.dataTransfer.files[i])
      }
      if (files.length) {
        return files
      }
    }
    return null
  }
}

const PUBLIC = {
  clone() {
    return ADNDDropFilesTarget()
  }
}

export default function ADNDDropFilesTarget({ dynamicPosition = false } = {}) {
  const ADNDDropFilesTarget = extendADNDDropTarget({ acceptTypes: ['files'], dynamicPosition })

  ADNDDropFilesTarget.PRIVATE.fetchData = PRIVATE.fetchData.bind(ADNDDropFilesTarget)

  ADNDDropFilesTarget.PUBLIC.clone = PUBLIC.clone.bind(ADNDDropFilesTarget)

  return ADNDDropFilesTarget.PUBLIC
}
